<!--  -->
<template>
  <div
    id="qrCode"
    ref="qrCodeDiv"
  ></div>
</template>

<script>
export default {
  components: {},
  props: {
    text: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
  },
  data() {
    return {};
  },
  watch: {
  },
  methods: {
    getQrCode() {
      new this.$qrCode(this.$refs.qrCodeDiv, {
        text: this.text,
        width: this.width,
        height: this.height,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: this.$qrCode.CorrectLevel.L, //容错率，L/M/H
      });
    },
  },
  created() {},
  mounted() {
    this.getQrCode();
  },
};
</script>
<style lang="scss" scoped></style>
